import { render, staticRenderFns } from "./AddEcosystemStartups.vue?vue&type=template&id=d3230f08&scoped=true&"
import script from "./AddEcosystemStartups.vue?vue&type=script&lang=js&"
export * from "./AddEcosystemStartups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3230f08",
  null
  
)

export default component.exports